import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { paymentMethodTranslation } from 'constants/payment';

const PaymentMethod = ({ method }) =>
  paymentMethodTranslation[method] ? <FormattedMessage id={paymentMethodTranslation[method]} /> : method;

PaymentMethod.propTypes = {
  method: PropTypes.string
};

export default PaymentMethod;
